'use strict';
namespace TR {

    type BookingService = Core.Booking.BookingService;
    type Booking = Core.Booking.Booking;

    class PassengerSelection {
        rootForm: any;
        trip : any;
        booking : Booking;
        rules : any;
        roomIndex : number;
        passengerIndex : number;
        visible : boolean;
        carHire : any;
        insurance : any;
        insuranceConfirmation: boolean = false;
        flight: any;
        hotel: any;
        attractions: any;

        isCrossSell : boolean = false;
        ageCheckDate : Date;
        requiredRooms;
        companions;
        driverOptions;
        skywardsLogin : boolean = false;
        skywardsUserDetails : any;
        enforceAgeValidation = TRPCONFIG.Domain.EnforceInsuranceAgeValidation;
        adultsWithInsurance;
        insuranceOptions;
        guestMinAge = TRPCONFIG.Domain.GuestMinAge;
        isSkywardsUserDetailsDisplayed = true;

        private selectedOptionId;
        private adultTitles : Function;
        private childTitles : Function;
        private detailsMatch : Function;


        constructor(private resourceService: Core.ResourceService,
                    private bookingService : BookingService,
                    private broker: Core.Broker,
                    private basketService,
                    private insuranceService,
                    private attractionService,
                    private dateUtil,
                    private $scope : ng.IScope,
                    private $location : ng.ILocationService) {
            this.adultTitles = resourceService.getDeferred('ADULTTITLES');
            this.childTitles = resourceService.getDeferred('CHILDTITLES');
            this.detailsMatch = bookingService.detailsMatch;
            const ignoreBooking = $scope.$watch('ps.bookingLoaded', b => {
                if(b) {
                    this.bookingInit();
                    ignoreBooking();
                }
            });
        }

        passengerInsuranceBand(bandId, costOnly) {
            return this.insuranceService.passengerInsuranceBand(this.insuranceOptions, bandId, costOnly);
        }

        copyFromContact(e) {
            this.bookingService.copyFromContact(this.booking, e);
        }

        getAttractionsDesc(id) {
            return this.attractionService.getAttractionsDesc(
                this.attractions, this.booking.UserData.AttractionDetails, id);
        }

        togglePrefilledUserDetails(event) {
            if (!this.isSkywardsUserDetailsDisplayed && event.type === 'click') {
                let firstGuest = this.requiredRooms[0]['Guests'][0];
                firstGuest['FirstName'] = this.skywardsUserDetails.data.Contact.FirstName;
                firstGuest['LastName'] = this.skywardsUserDetails.data.Contact.LastName;
                const loyaltyId =
                this.getMaskedSkywardsNum(this.skywardsUserDetails.data.Contact.LoyaltyId, null, null);
                this.skywardsIdUpdated(0, 0, loyaltyId);
            }
            return true;
        }

        private bookingInit() {
            if (_.get(this, 'trip.FlightsRequest') && this.flight) {
                const legs = this.flight.Details.Itinerary.Legs;
                this.ageCheckDate = <Date>(legs[legs.length-1].DepartureDate);
            }

            this.requiredRooms = this.mapRooms(_.get(this, 'booking.UserData.Rooms', []), this.rules);
            this.requiredRooms.additionalDrivers = _.get(this, 'carHire.AdditionalDrivers', 0);

            this.requiredRooms.map(room => {
                var counts = this.resetPassengerCounts();
                room.Guests.map(guest => {
                    counts[guest.Type]++;
                    guest.count = counts[guest.Type];
                    if(!TRPCONFIG.Domain.PrepopulateInsuranceAgeBands){
                        guest.InsuranceBandId = -1;
                    }
                });
                return room;
            });

            if (this.flight && TRPCONFIG.Domain.AllowFillingFromCompanions === true) {
                this.companions = _.get(this, 'booking.UserData.Companions', [])
                    .map(this.enhanceCompanion);
                this.companions = this.companions.length
                    ? this.companions.concat({
                        FirstName: '0',
                        LastName: '0' ,
                        Fullname: this.resourceService.get('ENTERANEWCOMPANION')
                    })
                    : null;
            }

            this.driverOptions = [
                { name: this.resourceService.get('NOTADRIVER'), value: Core.Booking.DriverType.NotADriver },
                { name: this.resourceService.get('MAINDRIVER'), value: Core.Booking.DriverType.MainDriver }
            ];

            if (this.requiredRooms.additionalDrivers) {
                this.driverOptions.push({
                    name: this.resourceService.get('ADDITIONALDRIVER'),
                    value: Core.Booking.DriverType.AdditionalDriver
                });
            }

            if (this.insurance) {
                if (!this.flight && _.get(this, 'trip.InsuranceRequest') && !this.ageCheckDate) {
                    this.ageCheckDate = <Date>(this.insurance.EndDate);
                }
                this.isCrossSell = !this.flight && /hotels/.test(this.$location.path());
                this.adultsWithInsurance = 0;
                this.insuranceOptions = this.booking.InsuranceBands;
                if(!TRPCONFIG.Domain.PrepopulateInsuranceAgeBands
                    && this.insuranceOptions && !_.some(this.insuranceOptions, (io: any) => io.Id === -1)){
                    //will have to find a better way to set this
                    this.insuranceOptions.push(
                        { Id:-1,
                        Label: this.resourceService.get('PLEASESELECT'),
                        PassengerType: 1}
                    );
                }
                this.selectedOptionId = _.get(this, 'insurance.Options[0].OptionId');
                this.adultsWithInsurance = _.reduce(this.booking.UserData.Rooms, (acc, r:any) => {
                    return _.some(r.Guests, { Type: 1 }) ? acc + 1 : acc;
                }, 0);
                if(TRPCONFIG.Domain.CheckInsuranceForceAge) {
                    this.broker.subscribe('passengerSelection', 'dobUpdated', () => {
                        if (this.enforceAgeValidation && this.flight) {
                            //update quotes only for cross sell
                            this.updateInsuranceQuote(this.booking);
                        }
                    });
                }
            }
            if (sessionStorage.getItem('skywardsLoginUser')) {
                this.skywardsUserDetails = JSON.parse(sessionStorage.getItem('skywardsLoginUser') || '{}');
                if (this.skywardsUserDetails) {
                    this.skywardsLogin = this.skywardsUserDetails.data.Identity.Email ? true : false;
                } else {
                    this.skywardsLogin = false;
                }
                this.isSkywardsUserDetailsDisplayed = this.skywardsLogin;
            } else {
                this.isSkywardsUserDetailsDisplayed = false;
            }
            }

        private resetPassengerCounts() {
            var counts = {};
            counts[Core.Booking.PassengerType.Adult] = 0;
            counts[Core.Booking.PassengerType.Child] = 0;
            counts[Core.Booking.PassengerType.Infant] = 0;
            return counts;
        }

        private enhanceCompanion(c) {
            return _.assign(c, { Fullname : `${c.Title} ${c.FirstName} ${c.LastName}`});
        }

        titles(p) {
            switch(p.Type) {
                case Core.Booking.PassengerType.Child:
                case Core.Booking.PassengerType.Infant:
                    return this.childTitles().split(',');
                case Core.Booking.PassengerType.Adult:
                case Core.Booking.PassengerType.AdultSwimmer:
                case Core.Booking.PassengerType.AdultNonSwimmer:
                case Core.Booking.PassengerType.ChildSwimmer:
                case Core.Booking.PassengerType.ChildNonSwimmer:
                    return this.adultTitles().split(',');
                default: return [''];
            }
        }

        getPassengerType(type) {
            if(type > 0) {
                switch(type) {
                case Core.Booking.PassengerType.Adult:
                    return this.resourceService.get('ADULT');
                case Core.Booking.PassengerType.Child:
                    return this.resourceService.get('CHILD');
                case Core.Booking.PassengerType.Infant:
                    return this.resourceService.get('INFANT');
                }
            }
            return '';
        }

        private mapRooms(rooms, rules) {
            if (rules.hotelOnly && !TRPCONFIG.Domain.AllGuestDetailsRequired) {
                return rooms.map(r =>
                    ({ Guests: [_.assign(r.Guests[0], { Label : this.resourceService.get('LEADGUEST')})]}));
            }
            return rooms;
        }

        passengerSelected (guest) {
            //update the names etc with that of the chosen one
            if (guest.PrefillFrom != null) {
                if (guest.PrefillFrom.FirstName === '0' &&
                    guest.PrefillFrom.LastName === '0') {
                    guest.FirstName = guest.LastName = guest.Title = '';
                    guest.dob = '';
                } else {
                    _.assign(guest, guest.PrefillFrom);
                }
            }
            if(sessionStorage.getItem('skywardsLoginUser')){
                guest.FirstName = guest.LastName = guest.Title = '';
                guest.dob = '';
            }
        }

        private back(booking : Booking) {
            this.broker.publish('PassengersSelected', booking);
        }

        ok() {
            this.bookingService.updateBooking(this.booking).then(() => {
                if (this.insurance) {
                    this.updateInsuranceQuote(this.booking);
                }
                this.back(this.booking);
            });
        }

        updateInsuranceQuote(booking) {
            const ages = this.updateInsuranceBandSelections(booking);
            const params = this.flight
                ? {
                    oneWayOnly: this.flight.OneWayOnly
                }
                : {
                    airport: _.get(this, 'hotel.Details.LinkedAirports[0]'),
                    dates: {
                        arrivalDate: _.get(this, 'hotel.Details.Itinerary.CheckInDate'),
                        departureDate: _.get(this, 'hotel.Details.Itinerary.CheckOutDate')
                    }

                };

            return this.basketService.updateInsuranceQuote(
                this.trip.BasketId, this.trip.TripId, this.selectedOptionId, { ages,  ...params }
            ).then(() => {
                this.broker.publish('bookingBasketUpdated', angular.copy(booking.UserData));
                this.broker.publish('basketUpdated');
                return;
            });
        }

        copyoverSkywards() {
            let passengerLoyalityNumber =
                (<HTMLInputElement>document.querySelectorAll
                    ('[name="passengers"] .guest-panel [name="loyaltyNumber"]')[0]).value;

            let skywardsNoIsDisabled =
                (<HTMLInputElement>document.querySelector
                    (`.contact-section.page-content-panel [name="contactForm"]
                    [name="LoyaltyNumber"][disabled="disabled"]`));

            let contactFirstName =
                (<HTMLInputElement>document.querySelector
                    ('.contact-section.page-content-panel [name="contactForm"] [name="firstName"]')).value;
            let contactLastName =
                (<HTMLInputElement>document.querySelector
                    ('.contact-section.page-content-panel [name="contactForm"] [name="lastName"]')).value;

            let passengerFirstName =
                (<HTMLInputElement>document.querySelectorAll
                    ('[name="passengers"] .guest-panel [name="firstName"]')[0]).value;
            let passengerLastName =
                (<HTMLInputElement>document.querySelectorAll
                    ('[name="passengers"] .guest-panel [name="lastName"]')[0]).value;

            if (!skywardsNoIsDisabled && contactFirstName === passengerFirstName
                && contactLastName === passengerLastName) {
                (<HTMLInputElement>document.querySelector
                    ('.contact-section.page-content-panel [name="contactForm"] [name="LoyaltyNumber"]'))
                    .value = passengerLoyalityNumber;
            } else if (!skywardsNoIsDisabled &&
                (contactFirstName !== passengerFirstName || contactLastName !== passengerLastName)) {
                (<HTMLInputElement>document.querySelector
                    ('.contact-section.page-content-panel [name="contactForm"] [name="LoyaltyNumber"]')).value = '';
            }
            sessionStorage.setItem('SkywardsLoyalityNumber', passengerLoyalityNumber);

        }

        getPassengerLabel(label) {
        // AT-286 remove child age for standalone attractions
            if(this.rules == null) {
                return undefined;
            }
            return this.rules.isAttractionsStandalone
                ? label.replace(/ \(age 3\)/, '')
                : label;
        }

        SkywardsMembershipNumberCharacterLimit() {
            return TRPCONFIG.Domain2.SkywardsMembershipNumberCharacterLimit;
        }

        getRawSkywardsNum(skywardsNumber) {
            if (!skywardsNumber || skywardsNumber === '') { return;}

            skywardsNumber = skywardsNumber.replaceAll(' ', '');
            return skywardsNumber;
        }

        getMaskedSkywardsNum(skywardsNum, roomIndex, guestIndex) {
            let guest = this.requiredRooms[roomIndex].Guests[guestIndex];
            if (!skywardsNum || skywardsNum.length < 9) {return;}
            let str = skywardsNum.toString();
            let numbers = '';
            for (let i = 0; i < str.length; i++) {
                if (!isNaN(str[i])) {
                    numbers += str[i];
                }
            }
            guest.LoyaltyNumber = numbers;
            guest.TempLoyaltyNumber = numbers;
            return numbers;
        }

        skywardsIdUpdated(roomIndex, guestIndex, value) {
            let guest = this.requiredRooms[roomIndex].Guests[guestIndex];
            if (!value || value === '') {
                guest.LoyaltyNumber = '';
                guest.TempLoyaltyNumber = '';
                return;
            }
            // remove chars other than number type
            let onlyDigits = value.split('').filter(function(s) { return (!isNaN(s) && s !== ' '); }).join('');

            // Handle copy paste cases
            if (onlyDigits.length >= 9) {
                if (onlyDigits.length <= 11 ) {
                    guest.LoyaltyNumber = onlyDigits;
                    let guestContactName = guest.Title +  guest.FirstName + guest.LastName;
                    let leadContactName = this.booking.UserData.Contact.Title + this.booking.UserData.Contact.FirstName
                    + this.booking.UserData.Contact.LastName;
                    if (leadContactName === guestContactName && this.booking.UserData.Contact.LoyaltyNumber === '') {
                        this.booking.UserData.Contact.LoyaltyNumber = guest.TempLoyaltyNumber;
                    }
                    guest.TempLoyaltyNumber = onlyDigits;

                    return;
                }
                guest.LoyaltyNumber = onlyDigits;
                guest.TempLoyaltyNumber = onlyDigits;
                return;
            } else if (onlyDigits.length === 0) {
                guest.LoyaltyNumber = '';
                guest.TempLoyaltyNumber = '';
                return;
            }
            guest.LoyaltyNumber = this.getRawSkywardsNum(value);
            guest.TempLoyaltyNumber = value;
        }

        private updateInsuranceBandSelections(booking) {
            //if the insurance band price is 0 && it is an adult passenger treat it as not available
            const excludedBandIds = _.map(_.filter(this.insuranceOptions, { Available: false }), 'Id');
            let {childAges, adultAges} = _.reduce(this.booking.UserData.Rooms, (acc, r:any) => {
                return _.reduce(r.Guests, (acc: any, g: any) => {
                    //set the band depending on the dob selected, check if the guest does not want insurance
                    if (g.DateOfBirth && g.InsuranceBandId > 0) {
                        const age = this.dateUtil.getAge(g.DateOfBirth, this.ageCheckDate);
                        const selectedInsuranceBand: any = _.find(this.insuranceOptions, (option: any) =>
                            age <= option.EndAge && age >= option.StartAge
                        );
                        if (selectedInsuranceBand) {
                            g.InsuranceBandId = selectedInsuranceBand.Id;
                        }
                        else {
                            g.InsuranceBandId = null;
                        }
                    }
                    if (g.InsuranceBandId > 0 && _.indexOf(excludedBandIds, g.InsuranceBandId) === -1) {
                        if (g.Type === 1) {
                            acc.adultAges.push(g.InsuranceBandId);
                        } else {
                            acc.childAges.push(g.InsuranceBandId);
                        }
                    }
                    return acc;
                }, acc);
            }, {childAges:[], adultAges:[]});

            if (adultAges.length === 0 && childAges.length > 0) {
                //clear child insurance ages
                booking.UserData.Rooms.forEach(r => {
                    r.Guests.forEach(g => {
                        if (g.Type !== 1) {
                            g.InsuranceBandId = null;
                        }
                    });
                });
                childAges = [];
            }

            this.adultsWithInsurance = adultAges.length;
            return adultAges.concat(childAges);
        }
    }

    angular
        .module('TR')

                .directive('passengerSelection', (): ng.IDirective => {
            return {
                restrict: 'E',
                replace : true,
                scope: {
                    rootForm: '=',
                    trip : '=',
                    booking : '=',
                    rules : '=',
                    carHire: '=',
                    insurance: '=',
                    flight: '=',
                    hotel: '=',
                    attractions: '=',
                    roomIndex : '=',
                    passengerIndex : '=',
                    visible : '=',
                    bookingLoaded : '=',
                },
                bindToController : true,
                templateUrl : function(element, attr) {
                    if(attr.templateVersion){
                        return 'partials/booking/template?name=PassengerSelection&version=' + attr.templateVersion;
                    }
                    return 'partials/home/directivetemplate?type=PassengerSelection';
                },
                controller: PassengerSelection,
                controllerAs: 'ps',
            };
        });
}
